/**
 * Leaving the page for a URL, as one function a test can stand in for.
 *
 * `window.location` cannot be stubbed under jsdom - its properties are
 * unforgeable - so a screen that sends the browser to a URL it did not
 * build (a signed download link, say) calls this instead, and its test spies
 * on this object. The real thing is a plain assignment.
 */
export const navigation = {
  assign(url: string): void {
    window.location.assign(url);
  },
};
